import mergeOperations from '@/util/shallowMerge';
import { useMutation } from '@apollo/client';
import { useMemo, useState } from 'react';
import type { ResponseRoot } from '../types/response';
import { FormSchema } from '../warranty-registeration-form';
import DEFAULT_OPERATIONS from './warrantyPage.gql';

export const useWarrantyPage = ({ afterSubmit }: { afterSubmit: any }) => {
  const operations = mergeOperations(DEFAULT_OPERATIONS);
  const { addWarrantyInfoMutation } = operations;

  const [isLoading, setIsLoading] = useState(false);

  const [addWarrantyInfo, { data, error: addWarrantyInfoError }] = useMutation(addWarrantyInfoMutation, {
    fetchPolicy: 'no-cache',
  });

  const handleSubmit = async (values: FormSchema) => {
    const {
      email,
      firstname,
      lastname,
      phone,
      birthday,
      gender,
      order_number,
      website,
      purchased_item_category,
      usage,
      platform,
      website_other,
      platform_other,
      country_id,
    } = values;

    setIsLoading(true);

    let birthdayFormat = '';

    birthdayFormat = birthday.replace(/\D/g, '');

    if (birthdayFormat.length === 8) {
      const year = birthdayFormat.slice(4, 8);
      const month = birthdayFormat.slice(0, 2);
      const day = birthdayFormat.slice(2, 4);

      birthdayFormat = `${year}-${month}-${day}`;
    }

    try {
      const response = (await addWarrantyInfo({
        variables: {
          email,
          firstname,
          lastname,
          phone,
          gender,
          birthday: birthdayFormat,
          increment_id: order_number,
          website: parseInt(website),
          website_other,
          purchased_item_category,
          use: usage,
          platform,
          platform_other,
          tags: ['Source-Warranty'],
          country_id,
        },
      })) as ResponseRoot;

      if (typeof window !== 'undefined') {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'registered_warranty',
          warranty_email: email,
          warranty_order_number: order_number,
        });
      }

      if (afterSubmit) {
        afterSubmit({
          response,
        });
      }
    } catch (error) {
      if (process.env.NODE_ENV !== 'production') {
        console.error(error);
      }
    } finally {
      setIsLoading(false);
    }
  };

  const errors = useMemo(() => new Map([['addWarrantyInfoError', addWarrantyInfoError]]), [addWarrantyInfoError]);

  return {
    isBusy: isLoading,
    isLoading,
    errors,
    handleSubmit,
    response: data && data.addWarrantyInfo,
  };
};
